import { borderRadius, colors, shadows, spacing } from '../KestrixDesignSystem.jsx';
import { colorTokens } from '../tokens/colors.ts';

/** Shared layout and colour tokens for property table headers. */
export const propertyTableHeaderTokens = {
  surface: colorTokens.table.header.surface,
  border: colorTokens.table.header.border,
  /** Vertical divider between columns. */
  columnBorder: colors.neutral[100],
  /** Right edge of the last frozen column. */
  pinnedEdgeBorder: colors.neutral[400],
  height: colorTokens.table.header.height,
  cornerRadius: borderRadius.lg,
  contentGap: spacing[1],
  /** Inset from the left column divider. */
  cellPaddingLeft: spacing[3],
  /** Inset from the right column divider, matching the left inset. */
  cellPaddingRight: spacing[3],
  primaryDotSize: colorTokens.table.header.primaryDotSize,
  text: colorTokens.text.bodyNeutral,
  primaryDot: colorTokens.semantic.brand.primary,
  tooltipIcon: colorTokens.text.subtextNeutral,
  pinnedColumnShadow: shadows.tablePinnedColumn,
  /**
   * Fallback table min-width when any column uses a `%` width. Percentage
   * sticky offsets stay consistent at any table size. This value is the
   * viewport width below which the table scrolls instead of compressing.
   */
  scrollMinWidth: 1372,
} as const;
